import { render, staticRenderFns } from "./RowForm.vue?vue&type=template&id=54248aa4&scoped=true&"
import script from "./RowForm.vue?vue&type=script&lang=js&"
export * from "./RowForm.vue?vue&type=script&lang=js&"
import style0 from "./RowForm.vue?vue&type=style&index=0&id=54248aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54248aa4",
  null
  
)

export default component.exports